import { createContext, useContext } from "react";
import type { ItemNameCache } from "./itemNameCache";

export const ItemNameContext = createContext<ItemNameCache | null>(null);

export function useItemNames(): ItemNameCache {
  const cache = useContext(ItemNameContext);
  if (cache === null) {
    throw new Error("ItemReferenceName requires ItemNameProvider.");
  }
  return cache;
}
